import React, { useEffect } from 'react';

const pdfFileUrl = require('../../assets/pdfs/semaokulu_misafir_defteri.pdf');

interface PDFViewerProps {
  pdfSource: any;
  title:string;
}

const PDFViewer = (props:PDFViewerProps) => {
  const handleContextMenu = (e: any) => {
    e.preventDefault();
  };

  const handleKeyDown = (e: any) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'c')) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu);

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="guest-notebook">
      <a 
        href={props.pdfSource} 
        target="_blank" 
        rel="noopener noreferrer"
        className='guest-notebook_link'
      >
        {props.title}
        
      </a>
    </div>
  );
};

export default PDFViewer;
